// Copyright (c) Hamilton Manufacturing Corp.
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Bar = styled.div`
    width: 100%;
    height: 0.2em;

    animation: BarCountDown linear;
    animation-duration: ${({ time }) => time}s;
`

const CountDown = ({ type = 'text', time, callback, ...props }) => {

    const Ref = useRef(null);
    const [timer, setTimer] = useState('');

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);

        if (total === 0) {
            callback();
        }

        return {
            total, hours, minutes, seconds
        };
    }

    const startTimer = (e) => {
        let { total, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            setTimer(
                (minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds)
            )
        }
    }

    const clearTimer = (e) => {
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }

    const getDeadTime = () => {
        let deadline = new Date();
        deadline.setSeconds(deadline.getSeconds() + time);
        return deadline;
    }

    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);

    return type === 'text' ? <span>{timer}</span> : type === 'bar' ? <Bar time={time} /> : <Bar />
}

export default CountDown;
